// Names and enum values that more than one call site has to agree on.
//
// GA4 accepts any event name and any parameter value without complaint, so a
// typo does not fail — it lands in the property as a new, empty event name that
// no report and no key-event registration will ever match. That is the same
// silent-no-op shape as the missing GOOGLE_DRIVE_CLIENT_ID (#477) and
// TYPESENSE_HOST: nothing throws, nothing logs, and the only symptom is a
// number that is quietly too low. A shared constant turns that into a
// ReferenceError at build time.
//
// Deliberately not exhaustive. Only the names used at more than one call site
// live here; a single-use event name is spelled inline where it is sent, where
// a reader can see it next to the code that earns it.

export const EVENTS = {
  SEARCH_PERFORMED: 'search_performed',
  DOWNLOAD_CREATED: 'download_created',
};

/**
 * The screen an event came from — the `surface` parameter.
 *
 * Named `surface` rather than `source` because GA4 already has a built-in
 * Source dimension for traffic acquisition (google / direct / a referrer), and
 * two things called Source in the same reporting UI is a permanent ambiguity
 * for whoever builds the report six months from now.
 *
 * UNKNOWN is a sentinel, not a screen. It exists so a future call site that
 * forgets to name its surface shows up as a visible gap rather than being
 * filed under a real one — the same reasoning as the whole-context rule in
 * analyticsService: a missing value is recoverable, a confidently wrong one is
 * not. Nothing should ever pass it deliberately.
 */
export const SURFACE = {
  // Task download surfaces
  TASK_LIST: 'task_list',
  TASK_ID_HISTORY: 'task_id_history',
  TASK_DETAIL: 'task_detail',
  CUSTOMER_PORTAL: 'customer_portal',
  // Search surfaces
  GLOBAL_SEARCH: 'global',
  ADVANCED_SEARCH: 'advanced',
  // Sentinel
  UNKNOWN: 'unknown',
};
